module.exports = __webpack_public_path__ + "img/b_Plantofer_MainView.16c8ecff.jpg";